import type { Styles } from './types';

const fullHeight = { height: '100%' };

export const styles: Styles = {
  html: fullHeight,
  body: fullHeight,
  'div#root': fullHeight,
};
